import React, { useEffect, useState, useCallback } from 'react';
import SoundManager from '../../../Sound/SoundManager';
import './ReactCaption.css';

(window as any).CCEnabled = true;

const ReactCaption = (obj: any) => {
	const [closedCaptions, setClosedCaptions] = useState(SoundManager.hiddenCaption);
	const closedCaptionsCallback = useCallback(
		() => {
			(window as any).CCEnabled = !(window as any).CCEnabled;
			setClosedCaptions((closedCaptions: boolean) => !closedCaptions);
			if((window as any).forceUpdateCC) {
				(window as any).forceUpdateCC();
			}
		},
		[obj],
	);


	const onChangeValueKeyboard = (e: any) => {
		if (e.keyCode == 32 || e.keyCode == 13) { //32 - spacebar, 36 - enter
			closedCaptionsCallback();
		}
	};

	var renderCaption = () => {
		return (
			<>
				<div className="captions-icon"
					style={{
						zIndex: 10,
						pointerEvents: 'all'
					}}
					id='cc-bttn'
					aria-label="Toggle Captions"
					role="button"
					tabIndex={0}
					onClick={closedCaptionsCallback}
					onKeyDown={onChangeValueKeyboard}>
					<img className="pointer" src={!(window as any).CCEnabled ? './assets/images/closed-captioning-off.png' : './assets/images/closed-captioning-on.png'} />
				</div>

				<div  style={{
					width: '5%',
					position: 'absolute',
					top: '17%',
					left: '1%',
					cursor: 'pointer',
					zIndex: 10,
					pointerEvents: 'all'
				}}
				aria-label="Toggle Mute"
				role="button"
				id='last-object-main'
				tabIndex={0}
				onKeyUp={(window as any).mapDivEnterToClick}
				onClick={() => {
					(window as any).onToggleMute();
				}}>
					<img className="pointer" src={(window as any).isMuted() ? './assets/images/audioOff.svg' : './assets/images/audioOn.svg'} />
				</div>

				{obj.currentCaption && !obj.isPaused && <div className="caption-container">
					{(window as any).CCEnabled &&
						<div className="caption-block">
							<p tabIndex={0} className="caption-paragraph" dangerouslySetInnerHTML={{__html: obj.currentCaption}}>
							</p>
						</div>
					}
				</div>
				}
			</>
		);
	};

	return (
		<>
			{renderCaption()}
		</>
	);
};

export default ReactCaption;